import Vue from 'vue';
import loading from '../components/Loading.vue';

//使用extend创建的是一个组件构造器
const loadingConstructor = Vue.extend(loading);

//实例化组并创建一个div
let instance: any = new loadingConstructor({
  el: document.createElement('div'),
});

const newLoading: any = {
  interval: 300,
  clearTime: null,
  show(options: any) { // 接受传递过来的问题，调用此方法时同事显示弹窗
    instance.show = true;
    //判断是否有传值过来，有就改变默认值
    if (options) {
      instance.text = options;
    }
    this.clearTime = setTimeout(() => {
      document.body.appendChild(instance.$el);
    }, this.interval);
  },
  hide() {
    // 如果在300毫秒内
    instance.show = false;
    clearTimeout(this.clearTime);
  }
};
const install = function () {
  if (!Vue.prototype.$loading) {
    Vue.prototype.$loading = newLoading;
  };
  Vue.mixin({
    created() {
      Vue.prototype.$loading = Vue.prototype.$loading
    }
  });
}
export default install;
